import "./App.css";
import "../src/styles/main.scss";
import MainRoutes from "./routes/routes";
import { useEffect, useRef } from "react";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import { LOGOUT } from "./redux/auth/authType";
import { logout } from "./utils/auth";
import decode from "jwt-decode";
import React from "react";

function App() {
  const { token } = useSelector((state) => (state as any)?.authReducer);

  const dispatch = useDispatch();
  const idleTimer = useRef<any>(null);
  const intervalTimer = useRef<any>(null);
  const doLogout = () => {
    Cookies.remove("token");
    Cookies.remove("services");

    dispatch({ type: LOGOUT });
    window.location.replace("/");
  };
  const handleIdleness = () => {
    const resetTimer = () => {
      if (idleTimer.current) clearTimeout(idleTimer.current);

      idleTimer.current = setTimeout(doLogout, 60 * 60 * 1000);
    };
    ["click", "mousemove", "keydown", "scroll", "touchstart"].forEach((evt) => {
      window.addEventListener(evt, resetTimer);
    });

    resetTimer();
  };
  const checkTokenExpiry = () => {
    if (!token) return;

    try {
      const decoded: any = decode(token);
      const exp = decoded.exp * 1000;
      const now = Date.now();

      if (now >= exp) {
        doLogout();
      }
    } catch (err) {
      doLogout();
    }
  };

  useEffect(() => {
    if (token) {
      handleIdleness();
      intervalTimer.current = setInterval(checkTokenExpiry, 10000);
    }

    return () => {
      if (intervalTimer.current) clearInterval(intervalTimer.current);
      if (idleTimer.current) clearTimeout(idleTimer.current);
    };
  }, [token]);

  return <MainRoutes />;
}

export default App;
